module.exports = "/images/storm.png?d498810a1131aa397922cf7fda6e1632";